import React, { Component } from "react";
import ReactDOM from 'react-dom'
import dialog from 'suneditor/src/plugins/modules/dialog';
import Spinner from '../../spinner-component/Spinner';
import MediaLibraryApi from "./api";
import "./media-library-style.css";



export class OsFileManager extends Component {

    constructor(props) {
        super(props);

        this.folder_id = 0;
        this.active_folder = {};

        this.folder_for_info = {};
        this.file_for_info = {};

        this.add_new_folder = false;
        this.add_new_file = false;

        this.api_process = false;

        this.folders = [];
        this.files = [];

        this.image_ext = ['jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'webp'];

        this.state = {
            'has_data' : false,
            'rebuild' : 1
        };
        console.log('render init')
    }


    /*================================================================*/
    /*=================== FOLDER START ===============================*/
    /*================================================================*/

    openAddNewFolderForm ( event ) {
        this.resetData();
        this.add_new_folder = true;
        this.setState({'rebuild' : this.state.rebuild + 1});
    }


    changeFolderName ( event ) {
        this.folder_for_info.name = event.target.value;
    }


    async deleteFolder () {
        if ( !this.api_process && window.confirm( this.props.labels.delete_confirm_text ) ) {
            this.api_process = true;
            let deleted = await MediaLibraryApi.deleteFolder( this.folder_for_info.id );
            this.api_process = false;
            if ( deleted ) {
                window.alert( this.props.labels.delete_folder_success_result );
                this.resetData();
                await this.getFolderContent();
            } else {
                window.alert( this.props.labels.delete_folder_error_result );
            }
        }
    }


    async saveFolderData () {
        if ( this.api_process )
            return false;

        this.api_process = true;

        let save_result = false;
        if ( this.folder_for_info.id ) {
           save_result = await MediaLibraryApi.updateFolder({
               'id'        : this.folder_for_info.id,
               'name'      : this.folder_for_info.name,
               'parent_id' : this.folder_id
           });
        } else {
            save_result = await MediaLibraryApi.addFolder({
                'name'      : this.folder_for_info.name,
                'parent_id' : this.folder_id
            });
        }

        this.api_process = false;

        if ( save_result ) {
            window.alert( this.props.labels.save_folder_success_result );
            this.resetData();
            await this.getFolderContent();
        } else {
            window.alert( this.props.labels.save_folder_error_result );
        }
    }


    async changeFolderForInfo ( selected_folder = {}, back = 0 ) {
        if ( back ) {
            this.resetData();
            this.folder_id = this.active_folder.parent_id;
            this.active_folder = {};
            await this.getFolderContent();
        } else if ( typeof(this.folder_for_info.id) === 'undefined' || this.folder_for_info.id !== selected_folder.id ) {
            this.resetData();
            this.folder_for_info = selected_folder;
            this.setState({'rebuild' : this.state.rebuild + 1});
        } else if ( this.folder_for_info.id === selected_folder.id ) {
            this.resetData();
            this.active_folder = selected_folder;
            this.folder_id = selected_folder.id;
            await this.getFolderContent();
        }
    }

    /*================================================================*/
    /*=================== FOLDER END =================================*/
    /*================================================================*/









    /*================================================================*/
    /*=================== FILES START ================================*/
    /*================================================================*/

    openAddNewFileForm () {
        this.resetData();
        this.add_new_file = true;
        this.setState({'rebuild' : this.state.rebuild + 1});
    }


    changeSelectedFile ( event ) {
        let file = event.target.files[0];
        if (!file) return;

        let file_name_for_service = file.name;
        let file_name_info = file.name.split(/[#?]/)[0].split('.');
        if ( file_name_info.length > 1 ) {
            let last_index = file_name_info.length - 1;
            let file_ext = file_name_info[ last_index ];
            file_name_info.splice(last_index, 1);
            file_name_info.push( Date.now() );
            file_name_for_service = file_name_info.join('_') + '.' + file_ext;
        }

        this.file_for_info.file = file;
        this.file_for_info.name = file_name_for_service;
        this.file_for_info.description = file_name_for_service;
    }


    changeFileForInfo ( selected_file = {} ) {
        this.resetData();
        this.file_for_info = selected_file;
        this.setState({'rebuild' : this.state.rebuild + 1});
    }


    async deleteFile () {
        if ( !this.api_process && window.confirm( this.props.labels.delete_confirm_text ) ) {
            this.api_process = true;
            let deleted = await MediaLibraryApi.deleteFile( this.file_for_info.id );
            this.api_process = false;
            if ( deleted ) {
                window.alert( this.props.labels.delete_file_success_result );
                this.resetData();
                await this.getFolderContent();
            } else {
                window.alert( this.props.labels.delete_file_error_result );
            }
        }
    }


    async saveFileData () {
        if ( this.api_process || typeof(this.file_for_info.file) !== 'object' )
            return false;

        let file_form_data = new FormData();
        file_form_data.append( 'folder_id', this.folder_id );
        file_form_data.append( 'name', this.file_for_info.name );
        file_form_data.append( 'description', this.file_for_info.description );
        file_form_data.append( 'file', this.file_for_info.file );

        this.api_process = true;

        let add_file_result = await MediaLibraryApi.addFile( file_form_data );

        this.api_process = false;

        if ( add_file_result ) {
            window.alert( this.props.labels.save_file_success_result );
            this.resetData();
            await this.getFolderContent();
        } else {
            window.alert( this.props.labels.save_file_error_result );
        }
    }


    getFileExtension ( file_name = '' ) {
        return file_name.split(/[#?]/)[0].split('.').pop().trim();
    }

    /*================================================================*/
    /*=================== FILES START ================================*/
    /*================================================================*/


    cancelChanges () {
        this.resetData();
        this.setState({'rebuild' : this.state.rebuild + 1});
    }


    resetData () {
        this.file_for_info = {};
        this.folder_for_info = {};
        this.add_new_file = false;
        this.add_new_folder = false;
    }


    async getFolderContent () {
        this.setState({'has_data' : false});

        if ( this.folder_id > 0 && !Object.keys(this.active_folder).length ) {
            this.active_folder = await MediaLibraryApi.getFolderById( this.folder_id );
        }

        this.folders = await MediaLibraryApi.getFoldersList( this.folder_id );

        this.files = await MediaLibraryApi.getFilesList( this.folder_id );

        console.log( this.files );

        this.setState({'has_data' : true});
    }


    renderLeftSectionContent () {
        let left_content = null;

        if ( Object.keys(this.folder_for_info).length || this.add_new_folder ) {
            let folder_delete_button = null;
            if ( this.folder_for_info.id ) {
                folder_delete_button = (<button
                                            className="btn btn-danger os-media-library-form-button"
                                            onClick={this.deleteFolder.bind(this)}
                                        >
                                            <span className="fa fa-trash"></span> {this.props.labels.folder_form_delete_button_text}
                                        </button>);
            }

            left_content = (<div key={"os-media-library-folder-form-id-" + this.folder_for_info.id || 0 }>
                <div className="form-group">
                    <label>{this.props.labels.folder_name_label_text}</label>
                    <input
                        className="form-control"
                        defaultValue={this.folder_for_info.name || ""}
                        onChange={this.changeFolderName.bind(this)}
                    />
                </div>
                <div className="form-group text-center">
                    <button
                        className="btn btn-success os-media-library-form-button"
                        onClick={this.saveFolderData.bind(this)}
                    >
                        <span className="fa fa-save"></span> {this.props.labels.folder_form_save_button_text}
                    </button>
                    {folder_delete_button}
                    <button
                        className="btn btn-dark os-media-library-form-button"
                        onClick={this.cancelChanges.bind(this)}
                    >
                        <span className="fa fa-times"></span> {this.props.labels.folder_form_cances_button_text}
                    </button>
                </div>
            </div>);
        } else if ( Object.keys(this.file_for_info).length || this.add_new_file ) {
            let file_delete_button = null;
            let file_top_form_section = null;
            let file_save_button = null;
            let file_preview = null;

            if ( this.file_for_info.id ) {
                file_delete_button = (<button
                                            className="btn btn-danger os-media-library-form-button"
                                            onClick={this.deleteFile.bind(this)}
                                        >
                                            <span className="fa fa-trash"></span> {this.props.labels.file_form_delete_button_text}
                                        </button>);

                let file_url = MediaLibraryApi.getImageUrl(this.file_for_info.file);
                let file_ext = this.getFileExtension( file_url );
                if ( this.image_ext.indexOf(file_ext) >= 0 ) {
                    file_preview = (<div style={{'textAlign' : 'center'}}>
                                        <img
                                            style={{
                                                    'maxWidth' : '100%',
                                                    'width' : 'auto',
                                                    'marginTop' : '10px',
                                                    'marginBottom' : '10px'
                                                }}
                                            src={file_url}
                                            alt="file preview"
                                        />
                                    </div>);
                }


                file_top_form_section = (<div className="col-lg-12" key={"file_info_" + this.file_for_info.id}>
                                            <div>
                                                <span>{this.props.labels.file_info_link_label}</span>
                                            </div>

                                                {this.props.onSave && file_url &&
                                                    <button
                                                        onClick={(e)=>{
                                                            e.preventDefault();
                                                            this.props.onSave(file_url)
                                                        }}
                                                        style={{
                                                            margin:'10px 0'
                                                        }}
                                                        className="btn btn-success"
                                                    >
                                                         Обрати файл
                                                    </button>
                                                }
                                            <div>
                                                <textarea
                                                    style={{'width' : '100%', 'height' : '100px'}}
                                                    defaultValue={file_url}
                                                ></textarea>
                                            </div>
                                        </div>);
            } else {
                file_save_button = (<button
                                        className="btn btn-success os-media-library-form-button"
                                        onClick={this.saveFileData.bind(this)}
                                    >
                                        <span className="fa fa-save"></span> {this.props.labels.file_form_save_button_text}
                                    </button>);
                file_top_form_section = (<div className="form-group">
                                            <label>{this.props.labels.file_form_select_file_input_label}</label>
                                            <input
                                                type="file"
                                                onChange={this.changeSelectedFile.bind(this)}
                                            />
                                        </div>);
            }

            left_content = (<div key={"os-media-library-file-form-id-" + this.folder_for_info.id || 0 }>
                                {file_top_form_section}
                                {file_preview}
                                <div className="form-group text-center">
                                    {file_save_button}
                                    {file_delete_button}
                                    <button
                                        className="btn btn-dark os-media-library-form-button"
                                        onClick={this.cancelChanges.bind(this)}
                                    >
                                        <span className="fa fa-times"></span> {this.props.labels.file_form_cances_button_text}
                                    </button>
                                </div>
                            </div>);

        }

        return left_content;
    }


    renderFolderContent () {
        let content = [];

        if ( !this.folders.length && !this.files.length && !this.folder_id ) {
            content.push(<div key="os-media-library-empty-label" className="text-center">{this.props.labels.empty_data_label}</div>);
        } else {

            if ( Object.keys(this.active_folder).length ) {
                content.push(<div
                                key="os-media-library-current-folder-name"
                                className="os-media-library-current-folder-name"
                            >
                                <span>
                                    <span className="fa fa-folder"></span> {this.active_folder.name}
                                </span>
                            </div>);
            }

            if ( this.folder_id > 0 ) {
                content.push(<div
                                key="os-media-library-back-folder"
                                className="os-media-library-folder"
                                onClick={this.changeFolderForInfo.bind(this, this.active_folder, 1)}
                            >
                                <div className="os-media-library-folder-image">
                                    <span className="fa fa-arrow-left"></span>
                                </div>
                                <div
                                    className="os-media-library-folder-name"
                                    title={this.props.labels.folder_return_back_name}
                                >
                                    {this.props.labels.folder_return_back_name}
                                </div>
                            </div>);
            }

            for ( let folder_key in this.folders ) {
                content.push(<div
                                key={"os-media-library-folder-" + this.folders[folder_key].id}
                                className="os-media-library-folder"
                                onClick={this.changeFolderForInfo.bind(this, this.folders[folder_key], 0)}
                            >
                                <div className="os-media-library-folder-image">
                                    <span className="fa fa-folder"></span>
                                </div>
                                <div
                                    className="os-media-library-folder-name"
                                    title={this.folders[folder_key].name}
                                >
                                    {this.folders[folder_key].name}
                                </div>
                            </div>);
            }

            for ( let file_key in this.files ) {
                content.push(<div
                                key={"os-media-library-file-" + this.files[file_key].id}
                                className="os-media-library-file"
                                onClick={this.changeFileForInfo.bind(this, this.files[file_key])}
                            >
                                <div className="os-media-library-file-image">
                                    <span className="fa fa-file"></span>
                                </div>
                                <div
                                    className="os-media-library-file-name"
                                    title={this.files[file_key].name}
                                >
                                    {this.files[file_key].name}
                                </div>
                            </div>);
            }

        }

        return content;
    }


    async componentDidMount () {
        await this.getFolderContent();
    }


    render () {
        let folder_content = null;
        if ( !this.state.has_data ) {
            folder_content = (<div className="col-lg-12 text-center"><Spinner /></div>);
        } else {
            folder_content = (<div className="row mr-0 ml-0">
                <div className="col-lg-3 os-media-library-content-file-info">
                    {this.renderLeftSectionContent()}
                </div>
                <div className="col-lg-9 os-media-library-content-files-list">
                    {this.renderFolderContent()}
                </div>
            </div>);
        }

        return (<>
            <div className="os-media-library-content-header">
                <span>
                    {this.props.labels.modal_title}
                </span>
                <button
                    type="button"
                    data-command="close"
                    className="se-btn se-dialog-close"
                    aria-label="Close"
                    title=""
                    onClick={this.props.onCloseModal}
                >
                    <span className="fa fa-times"></span>
                </button>
            </div>
            <div className="os-media-library-content">
                <div className="os-media-library-content-top-buttons">
                    <ul>
                        <li
                            title={this.props.labels.create_new_folder_button_title}
                            onClick={this.openAddNewFolderForm.bind(this)}
                        >
                            <span className="fa fa-folder-plus"></span>
                        </li>
                        <li
                            title={this.props.labels.upload_new_file_button_title}
                            onClick={this.openAddNewFileForm.bind(this)}
                        >
                            <span className="fa fa-file-circle-plus"></span>
                        </li>
                    </ul>
                </div>
                <div className="os-media-library-content-files">
                    {folder_content}
                </div>
            </div>
        </>);
    }

}







const OsMediaLibrary = {

	name : 'osMediaLibrary',
	display : 'dialog',
    labels : {},
    labels_by_langs : {
        'ua' : {
            'modal_title' : 'Медіа файли',
            'create_new_folder_button_title' : 'Додати нову папку',
            'upload_new_file_button_title' : 'Завантажити файл',
            'empty_data_label' : 'Медіа бібліотека пуста',
            'folder_return_back_name' : 'Назад',
            'folder_name_label_text' : 'Назва папки',
            'folder_form_save_button_text' : 'Зберегти',
            'folder_form_cances_button_text' : 'Скасувати',
            'folder_form_delete_button_text' : 'Видалити',
            'save_folder_success_result' : 'Папку було успішно збережено',
            'save_folder_error_result' : 'Папку не вдалося зберегти',
            'delete_confirm_text' : 'Ви бажаєте видалити вибрану інформацію?',
            'delete_folder_success_result' : 'Папку було видалено',
            'delete_folder_error_result' : 'Папку не вдалося видалити',
            'file_form_delete_button_text' : 'Видалити',
            'file_form_cances_button_text' : 'Скасувати',
            'file_form_save_button_text' : 'Зберегти',
            'file_form_select_file_input_label' : 'Виберіть файл для завантаження',
            'save_file_success_result' : 'Файл було успішно завантажено',
            'save_file_error_result' : 'Файл не вдалося завантажити',
            'file_info_link_label' : 'Посилання на файл',
            'delete_file_error_result' : 'Файл не вдалося видалити',
            'delete_file_success_result' : 'Файл було видалено'
        }
    },


	add : function (core) {
        core.addModule([dialog]);
        const context = core.context;
        context.osMediaLibrary = {
            'focusElement' : null,
            'targetSelect' : null,
            'linkAnchorText' : null,
            '_linkAnchor' : null
        };
        this.labels = this.labels_by_langs[core.lang.code] || this.labels_by_langs['ua'];
        let link_dialog = this.setDialog(core);
        context.osMediaLibrary.modal = link_dialog;
        context.dialog.modal.appendChild(link_dialog);
    },

    /** dialog */
    setDialog : function (core) {
        const dialog = core.util.createElement("DIV");
        ReactDOM.render( (<OsFileManager labels={this.labels} />), dialog );
        dialog.className = "os-media-library-content-wrapper";
        dialog.style.display = "none";
        return dialog;
    },

    open : function () {
        this.plugins.dialog.open.call(
            this,
            "osMediaLibrary",
            "osMediaLibrary" === this.currentControllerName
        );
    },

    submit : function (e) {
        this.showLoading();
        e.preventDefault();
        e.stopPropagation();
        return false;
    },

    init : function () {}


};


export default OsMediaLibrary;